import { styled } from "theme/default/styled";
import { setFlexDF } from "theme/setter/setFlexValues/setFlexDF";

export const SSupportAdministrationPageHeader = styled.div`
  ${setFlexDF};
`;
